import React from 'react';

export const optionsButton = ()=> {
    return (
    <svg x="0px" y="0px" width="26.88px" height="26.879px" viewBox="0 0 26.88 26.879">
        <g>
            <path d="M25.2,15.959l-2.1,0.35c-0.201,0.677-0.466,1.326-0.797,1.936l1.235,1.729c0.656,0.655,0.656,1.719,0,2.376
    		l-1.188,1.187c-0.656,0.656-1.72,0.656-2.376,0l-1.728-1.234c-0.609,0.331-1.258,0.596-1.935,0.797L15.96,25.2
    		c0,0.927-0.752,1.68-1.68,1.68H12.6c-0.928,0-1.68-0.752-1.68-1.68l-0.35-2.101c-0.677-0.201-1.326-0.466-1.936-0.797l-1.728,1.234
    		c-0.656,0.656-1.72,0.656-2.376,0L3.342,22.35c-0.656-0.657-0.656-1.721,0-2.376l1.235-1.729c-0.331-0.609-0.596-1.259-0.797-1.936
    		l-2.101-0.35c-0.928,0-1.68-0.752-1.68-1.68V12.6c0-0.928,0.752-1.681,1.68-1.681l2.101-0.35c0.201-0.677,0.466-1.326,0.797-1.935
    		L3.342,6.906c-0.656-0.656-0.656-1.719,0-2.375L4.53,3.342c0.656-0.656,1.72-0.656,2.376,0l1.728,1.235
    		C9.244,4.246,9.893,3.981,10.57,3.78l0.35-2.101C10.92,0.752,11.672,0,12.6,0h1.68c0.928,0,1.68,0.752,1.68,1.68l0.35,2.101
    		c0.677,0.201,1.326,0.465,1.935,0.796l1.729-1.235c0.656-0.656,1.72-0.656,2.376,0l1.188,1.188c0.656,0.656,0.656,1.72,0,2.375
    		l-1.235,1.729c0.331,0.609,0.596,1.258,0.797,1.935l2.101,0.35c0.928,0,1.68,0.753,1.68,1.681v1.679
    		C26.88,15.208,26.128,15.959,25.2,15.959z M24.36,12.6l-2.637-0.44c-0.209-1.36-0.744-2.612-1.521-3.674l1.553-2.175
    		c0.328-0.327,0.328-0.859,0-1.187c-0.328-0.328-0.86-0.328-1.188,0l-2.171,1.551c-1.062-0.781-2.314-1.32-3.678-1.529L14.28,2.52
    		c0-0.464-0.376-0.84-0.84-0.84c-0.464,0-0.84,0.376-0.84,0.84l-0.438,2.627c-1.364,0.209-2.616,0.747-3.679,1.529L6.312,5.124
    		c-0.328-0.328-0.86-0.328-1.188,0c-0.328,0.328-0.328,0.86,0,1.187l1.553,2.175C5.901,9.548,5.366,10.8,5.157,12.16L2.52,12.6
    		c-0.464,0-0.84,0.376-0.84,0.839c0,0.463,0.376,0.84,0.84,0.84l2.637,0.439c0.209,1.36,0.744,2.612,1.52,3.674l-1.553,2.174
    		c-0.328,0.328-0.328,0.86,0,1.188c0.328,0.329,0.86,0.329,1.188,0l2.171-1.551c1.062,0.782,2.314,1.32,3.679,1.529l0.438,2.627
    		c0,0.464,0.376,0.84,0.84,0.84c0.464,0,0.84-0.377,0.84-0.84l0.438-2.627c1.364-0.209,2.616-0.747,3.679-1.528l2.171,1.551
    		c0.328,0.329,0.86,0.329,1.188,0c0.328-0.328,0.328-0.86,0-1.188l-1.553-2.174c0.777-1.062,1.311-2.314,1.52-3.674l2.637-0.439
    		c0.464,0,0.84-0.377,0.84-0.84C25.2,12.976,24.824,12.6,24.36,12.6z M13.44,17.64c-2.32,0-4.2-1.881-4.2-4.2
    		c0-2.319,1.88-4.2,4.2-4.2c2.319,0,4.2,1.881,4.2,4.2C17.64,15.758,15.759,17.64,13.44,17.64z M13.44,10.919
    		c-1.392,0-2.52,1.128-2.52,2.521c0,1.392,1.128,2.52,2.52,2.52c1.392,0,2.52-1.128,2.52-2.52
    		C15.96,12.047,14.832,10.919,13.44,10.919z" fillRule="evenodd" clipRule="evenodd" fill="#332F36"></path>
        </g>
    </svg>
    )
};

export const editButton = ()=> {
    return (
    <svg x="0px" y="0px" width="26.01px" height="26.071px" viewBox="0 0 26.01 26.071">
        <path id="edit" d="M12.005,26.068v-2.004H26.01v2.004H12.005z M17.282,8.809l-0.927,1.58h0l-8.02,13.918l-6.573,1.765
    	L0,19.485l0.442-0.767l0.886-1.54l0.001,0.001L8.02,5.567l0,0l0.013-0.022L11.228,0l8.335,4.821l-2.294,3.981L17.282,8.809z
    	 M1.978,19.749l0.987,4.234l4.132-1.239l0.035-0.062l-5.134-2.97L1.978,19.749z M2.923,18.101l5.134,2.969l6.669-11.625l-5.134-2.97
    	L2.923,18.101z M11.816,2.601l-1.312,2.287l5.134,2.97l1.297-2.261L11.816,2.601z" fillRule="evenodd"
              clipRule="evenodd" fill="#ffffff"></path>
    </svg>
    )
};

export const moveButton = ()=> {
    return (
    <svg x="0px" y="0px" width="26.148px" height="26.116px" viewBox="0 0 26.148 26.116">
        <path id="move" d="M25.903,13.693c-0.037,0.037-0.083,0.054-0.124,0.082l-3.388,3.388c-0.331,0.331-0.867,0.331-1.198,0
    	c-0.331-0.331-0.331-0.867,0-1.198l1.873-1.873h-8.957v8.926l1.858-1.857c0.331-0.331,0.867-0.331,1.198,0
    	c0.331,0.33,0.331,0.867,0,1.198l-3.388,3.389c-0.029,0.041-0.046,0.087-0.083,0.124c-0.171,0.171-0.396,0.25-0.62,0.244
    	c-0.224,0.006-0.449-0.073-0.62-0.244c-0.037-0.037-0.054-0.083-0.083-0.125l-3.388-3.388c-0.331-0.331-0.331-0.867,0-1.198
    	c0.331-0.331,0.867-0.331,1.198,0l1.885,1.885v-8.954H3.082l1.873,1.873c0.331,0.331,0.331,0.867,0,1.198
    	c-0.331,0.331-0.867,0.331-1.198,0l-3.388-3.388c-0.041-0.028-0.088-0.046-0.124-0.082c-0.171-0.171-0.25-0.396-0.244-0.62
    	c-0.006-0.224,0.073-0.449,0.244-0.62c0.025-0.025,0.06-0.025,0.088-0.046l3.425-3.425c0.331-0.331,0.867-0.331,1.198,0
    	c0.331,0.331,0.331,0.868,0,1.199l-1.87,1.87h8.982V3.069l-1.885,1.886c-0.331,0.331-0.867,0.331-1.198,0
    	c-0.331-0.331-0.331-0.867,0-1.198l3.388-3.388c0.029-0.041,0.046-0.088,0.083-0.125c0.171-0.17,0.396-0.249,0.62-0.244
    	c0.224-0.006,0.449,0.073,0.62,0.244c0.037,0.037,0.054,0.083,0.083,0.124l3.388,3.388c0.331,0.331,0.331,0.867,0,1.198
    	c-0.331,0.331-0.867,0.331-1.198,0l-1.858-1.858v8.954h8.954l-1.87-1.87c-0.331-0.331-0.331-0.868,0-1.199
    	c0.331-0.331,0.867-0.331,1.198,0l3.425,3.425c0.027,0.021,0.063,0.021,0.088,0.046c0.171,0.171,0.25,0.396,0.244,0.62
    	C26.153,13.298,26.074,13.523,25.903,13.693z" fillRule="evenodd" clipRule="evenodd" fill="#ffffff"></path>
    </svg>
    )
};

export const deleteButton = ()=> {
    return (
    <svg x="0px" y="0px" width="24px" height="26.016px" viewBox="0 0 24 26.016">
        <g>
            <path d="M22,5.016v19c0,1.105-0.895,2-2,2H4c-1.105,0-2-0.895-2-2v-19H0v-2h4h3V0h10v3.016h3h4v2H22z M15,1.984H9
  		v1.031h6V1.984z M20,5.016H4v19h16V5.016z M9,21.016H7v-10h2V21.016z M13,21.016h-2v-12h2V21.016z M17,21.016h-2v-10h2V21.016z"
                  fillRule="evenodd" clipRule="evenodd" fill="#ffffff"></path>
        </g>
    </svg>
    )
};



// WEBPACK FOOTER //
// ./src/_app/drafts/svgs.jsx